export enum EBranch {
  Local = 'local',
  Development = 'develop',
  Test = 'master',
  Beta = 'beta',
  Production = 'production',
}

export const getProcessEnv = (variable: string): string => {
  const p: { [key: string]: string | undefined } = process.env;
  switch (process.env.VUE_APP_BRANCH) {
    case EBranch.Development:
      return p[`VUE_APP_DEV_${variable}`] as string;
    case EBranch.Test:
      return p[`VUE_APP_TEST_${variable}`] as string;
    case EBranch.Beta:
      return p[`VUE_APP_BETA_${variable}`] as string;
    case EBranch.Production:
      return p[`VUE_APP_PRODUCTION_${variable}`] as string;
    default:
      return p[`VUE_APP_LOCAL_${variable}`] as string;
  }
};

/**
 * Get station's configurator link
 */
export const getConfigLink = (): string => {
  switch (process.env.VUE_APP_BRANCH) {
    case EBranch.Development:
      return 'http://config.dev.podosmart.tech/';
    case EBranch.Test:
      return 'http://config.test.podosmart.tech/';
    case EBranch.Beta:
      return 'http://config.beta.podosmart.tech/';
    case EBranch.Production:
      return 'http://config.podosmart.tech/';
    default:
      return 'http://config.dev.podosmart.tech/';
  }
};
